import type { Text } from '../types/form'

type QuizAnswer = {
    _id: string
    isCorrect: boolean
    text: Text
}

export class Quiz {
    constructor(language: string, quizData?: Partial<Quiz>) {
        this.language = language
        if (quizData) {
            Object.assign(this, quizData)
            this.answers.forEach((answer) => (answer._id = crypto['randomUUID']()))
        } else {
            this.text = this.textObject()
            this.addAnswer()
            this.answers[0].isCorrect = true
        }
    }

    private language: string
    // @ts-ignore
    _id = crypto['randomUUID']()
    text = null as Maybe<Text>
    answers = [] as QuizAnswer[]
    kind = 'chooseOne'

    name = `form_fe['revision.heading_quizQuestionItem']`
    icon = 'fa fa-list-ul'

    private textObject(value: Maybe<string> = null) {
        return { [this.language]: value }
    }

    getCorrectAnswer() {
        const answer = this.answers.find((answer) => answer.isCorrect)
        return answer ? answer._id : null
    }

    setCorrectAnswer(id: string) {
        this.answers.forEach((answer) => {
            answer.isCorrect = answer._id === id
        })
    }

    addAnswer() {
        this.answers.push({
            // @ts-ignore
            _id: crypto['randomUUID'](),
            isCorrect: false,
            text: this.textObject(),
        })
    }

    removeAnswer(id: string) {
        this.answers = this.answers.filter((option) => option._id !== id)
        const correctAnswer = this.getCorrectAnswer()
        // removing answer is correct one, set first answer as new correct
        if (!correctAnswer && this.answers.length > 0) {
            this.answers[0].isCorrect = true
        }
    }
}
